export default "__VITE_ASSET__CWlZrnSK__"